import React, { useState, useEffect } from 'react';
import './Navbar.css';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  const handleLinkClick = () => {
    // Small delay to ensure navigation happens before menu closes
    setTimeout(() => {
      setIsMenuOpen(false);
    }, 100);
  };

  // Prevent body scroll when mobile menu is open
  useEffect(() => {
    if (isMenuOpen) {
      document.body.classList.add('mobile-menu-open');
    } else {
      document.body.classList.remove('mobile-menu-open');
    }

    // Cleanup on component unmount
    return () => {
      document.body.classList.remove('mobile-menu-open');
    };
  }, [isMenuOpen]);

  // Close menu on window resize (if user rotates device or resizes browser)
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 768 && isMenuOpen) {
        setIsMenuOpen(false);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [isMenuOpen]);

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <div className="navbar-brand">
          <h2><span className="alt">ALT</span> <span className="flow-logo">Flow</span></h2>
        </div>
        
        {/* Mobile menu toggle */}
        <button 
          className={`mobile-menu-toggle ${isMenuOpen ? 'active' : ''}`}
          onClick={toggleMenu}
          aria-label="Toggle mobile menu"
          aria-expanded={isMenuOpen}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
        
        <div className={`navbar-menu ${isMenuOpen ? 'mobile-open' : ''}`}>
          <div className="navbar-nav">
            <a href="#features" className="nav-link" onClick={handleLinkClick}>Features</a>
            <div className="nav-buttons">
              <a href="#faq" className="btn-faq" onClick={handleLinkClick}>FAQ</a>
              <a href="#access" className="btn black-color" onClick={handleLinkClick}>
                Get Access
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                  <path d="M1.67 10H16.67M10 3.33L16.67 10L10 16.67" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </a>
            </div>
          </div>
        </div>

        {/* Mobile overlay */}
        {isMenuOpen && (
          <div 
            className="mobile-overlay" 
            onClick={closeMenu}
            onKeyDown={(e) => e.key === 'Escape' && closeMenu()}
            role="button"
            tabIndex={0}
            aria-label="Close mobile menu"
          ></div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
